var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBulRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58048 7.73631L1.58077 7.7366L1.57236 7.74385C1.4888 7.81584 1.38111 7.85358 1.27089 7.84951C1.16068 7.84544 1.05606 7.79986 0.978038 7.7219C0.900017 7.64393 0.854373 7.53934 0.850298 7.42911C0.846223 7.31888 0.88402 7.21121 0.956076 7.1277L0.955764 7.12743L0.963625 7.11958L4.08614 3.99981L0.963626 0.880035L0.963335 0.880325L0.956076 0.871912C0.88402 0.7884 0.846223 0.680725 0.850298 0.570496C0.854373 0.460266 0.900017 0.355676 0.978038 0.27771C1.05606 0.199746 1.16068 0.154171 1.27089 0.150103C1.38111 0.146034 1.4888 0.18377 1.57236 0.255764L1.57263 0.255453L1.58048 0.263298L5.01103 3.69144L5.01132 3.69173C5.09277 3.77357 5.13851 3.88433 5.13851 3.99981C5.13851 4.11528 5.09277 4.22604 5.01132 4.30788L5.01103 4.30817L1.58048 7.73631Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBulRight);
export default __webpack_public_path__ + "static/media/ico-bul-right.6546a801a54d74f19c1ae5fb35e40e94.svg";
export { ForwardRef as ReactComponent };